import React, {Component} from 'react'
import TransactionIcon from '@material-ui/icons/SwapHoriz'
import Table, {TableRow, TableBody, TableHead, TableCell, styles as tableStyles} from 'components/CollapsibleTable'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import { DateTimeDisplay } from 'components'
import { Authorization } from 'utils/AuthorizationUtils'
import RefundIcon from '@material-ui/icons/Undo'
import CreateIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import StyleSheet from 'styles'
import { FlexDataItem } from 'components/FlexDataView'
import {NumberDisplay} from 'components/numbers'
import {FormattedMessage, injectIntl} from 'react-intl'

class Transactions extends Component {
  get showUsdConversion() {
    return this.props.allocation.transactions.some(t => t.usdAmount && Number(t.usdAmount) !== Number(t.amount))
  }

  get ticker() {
    return this.props.allocation.ticker || 'Unit';
  }

  render = () => {
    const {allocation, onRefund, onDelete, onCreate, intl} = this.props
    const isEquity = this.props.allocation.dealSheet.typeOfIssuance === 'equity'
    const isProduct = this.props.allocation.dealSheet.typeOfIssuance === 'product'
    return (
      <FlexDataItem size="large">
        <Typography variant='subtitle1' style={{paddingBottom: 15}}>
          <TransactionIcon /><FormattedMessage id="allocation.section.transactions" />
        </Typography>
        {Authorization.admin && (
          <Tooltip title="Add Transaction" placement="bottom">
            <IconButton color="primary" className={styles.createButton} onClick={() => onCreate(this.props.allocation)}>
              <CreateIcon />
            </IconButton>
          </Tooltip>
        )}
        <Table breakpoint={800} className={[styles.transactions, tableStyles.secondary].join(' ')}>
          <TableHead>
            <TableRow>
              <TableCell><FormattedMessage id="transactions.table.heading.confirmed_at" /></TableCell>
              <TableCell><FormattedMessage id="transactions.table.heading.id" /></TableCell>
              <TableCell className={tableStyles.numericCell}><FormattedMessage id="transactions.table.heading.value" /></TableCell>
              { !isEquity && <TableCell className={tableStyles.numericCell}><FormattedMessage id="transactions.table.heading.amount" /></TableCell> }
              {this.showUsdConversion &&
                <TableCell className={tableStyles.numericCell}>USD</TableCell>
              }
              {!isEquity && !isProduct && (
                <TableCell className={tableStyles.numericCell}>USD/{this.ticker}</TableCell>
              )}
              <TableCell className={styles.actionsCell} style={{paddingLeft: 0}} />
            </TableRow>
          </TableHead>
          <TableBody>
            {allocation.transactions.map(transaction =>
              <TableRow key={transaction.id}>
                <TableCell mobileHeading>
                  <DateTimeDisplay value={transaction.transactionConfirmedAt} singleLine/>
                  {transaction.status === 'refund_requested' && '*'}
                </TableCell>
                <TableCell mobileLabel={intl.formatMessage({id: 'transactions.table.heading.id'})}>
                  <Tooltip title={transaction.paymentIdentifier} placement="bottom">
                    <div className={styles.ellipsis}>{transaction.paymentIdentifier}</div>
                  </Tooltip>
                </TableCell>
                <TableCell mobileHeading className={tableStyles.numericCell}>
                  <NumberDisplay prefix={transaction.currency.prefix} suffix={transaction.currency.code}>{transaction.amount}</NumberDisplay>
                </TableCell>
                { !isEquity && <TableCell mobileLabel={intl.formatMessage({id: 'transactions.table.heading.amount'})} className={tableStyles.numericCell}>
                  <NumberDisplay suffix={transaction.ticker}>{transaction.tokensPurchased}</NumberDisplay>
                </TableCell> }
                {this.showUsdConversion &&
                  <TableCell mobileLabel="USD" className={tableStyles.numericCell}>
                    <NumberDisplay prefix="$">{transaction.usdAmount}</NumberDisplay>
                  </TableCell>
                }
                { !isEquity && !isProduct && (
                  <TableCell mobileLabel={`USD/${this.ticker}`} className={tableStyles.numericCell}>
                    ${transaction.usdUnitPrice}/{transaction.ticker}
                  </TableCell>
                )}
                <TableCell className={styles.actionsCell}>
                  {Authorization.admin && transaction.status !== 'is_refund' && transaction.status !== 'refunded' &&
                  <Tooltip title={`Refund Complete`} placement="bottom">
                    <IconButton aria-label="refund" onClick={() => onRefund(transaction)} className={styles.actionIconButton}><RefundIcon/></IconButton>
                  </Tooltip>
                  }
                  {Authorization.admin && transaction.source === 'manual' && (
                    <Tooltip title="Delete" placement="bottom">
                      <IconButton onClick={() => onDelete(transaction)} className={styles.actionIconButton}>
                        <DeleteIcon/>
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </FlexDataItem>
    )
  }
}

export default injectIntl(Transactions)

const styles = StyleSheet({
  ellipsis: {
    textOverflow: 'ellipsis',
    maxWidth: 80,
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'bottom',
    whiteSpace: 'nowrap',
  },
  transactions: {
    '&.collapsed .mobile-heading': {
      marginBottom: 10,
      fontWeight: 'bold',
      fontSize: '14px'
    }
  },
  actionIconButton: {
    margin: [-12, -3],
  },
  actionsCell: {
    textAlign: 'right'
  },
  createButton: {
    position: 'absolute',
    top: 2,
    right: 2,
  }
})